import { gql } from "@apollo/client"

const GET_SES_EMAIL_BATCHES = gql`
  query($input: SesEmailBatchesInput!) {
    sesEmailBatches(input: $input) {
      id
      notification_id
      no_of_emails
      no_of_queued
      no_of_delivered
      no_of_failed
      created_at
    }
  }
`

export { GET_SES_EMAIL_BATCHES }